module.exports = __webpack_public_path__ + "img/syntax-preview.2bd7a8f6.webp";